import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &&& {\n        color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import styled, { css } from "styled-components";
import "@sencrop/ui-icons/lib/sencrop-icon.css";
export var colors = {
  primary: ["text", "primary"],
  secondary: ["text", "secondary"],
  tertiary: ["text", "tertiary"],
  branding: ["branding", "primary"],
  success: ["action", "success"],
  danger: ["action", "danger"],
  warning: ["action", "warning"],
  info: ["action", "info"],
  light: ["text", "light"],
  dark: ["text", "dark"]
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var _ref2 = colors[props.color] || [null, null],
      _ref3 = _slicedToArray(_ref2, 2),
      group = _ref3[0],
      color = _ref3[1];

  return React.createElement(StyledIcon, _extends({}, props, {
    className: "si-".concat(props.name) + (className ? " ".concat(className) : ""),
    group: group,
    color: color
  }));
};

export default Icon;
var StyledIcon = styled.i.attrs(function (_ref4) {
  var size = _ref4.size,
      rotate = _ref4.rotate;
  return {
    style: {
      fontSize: size ? "".concat(size, "px") : null,
      transform: rotate ? "rotate(".concat(rotate, "deg)") : null
    }
  };
})(_templateObject(), function (props) {
  return props.color && css(_templateObject2(), props.theme.color(props.group, props.color));
});